<!--  -->
<template>
  <div class="announce-box" v-show="isShow">
    <Ptitle :chineseTitle="Ptitle.chinese" :enTitle="Ptitle.english"></Ptitle>
    <div class="top-wrapper">
      <head-box :title="title" class="head-box"></head-box>
      <router-link class="more" to="/announceCenter"
        ><span class="text">更多</span
        ><span><img src="../../../assets/images/double_arrow.png"/></span
      ></router-link>
    </div>
    <div class="announce-wrapper">
      <div
        class="announce-item"
        v-for="(item, index) in announceInfo"
        @click="toannouncePage(item.resourceId,item)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
import headBox from "../../../components/header/head";
import http from "../../../api/http.js";
import apiUrl from "../../../api/apiUrl.js";
import Ptitle from '../../../components/header/title.vue'

export default {
  data() {
    return {
      title: "质量公告",
      announceInfo: [],
      pageNumber: 1,
      pageSize: 6,
      channel: 3,
      isShow: false,
      Ptitle: {
        chinese: '行业资讯',
        english: 'NEWS'
      }
    };
  },

  props: [],

  watch: {},

  components: {
    headBox,
    Ptitle
  },

  computed: {},

  created() {
    this.fetchannounceInfo();
  },

  methods: {
    toannouncePage(id,item) {
      console.log(id)
      console.log(item)
      this.$router.push({ name: "AnnouncePage", query: { announceId: id },params: item });
    },
    // 获取新闻页数据
    fetchannounceInfo() {
      let url =
        apiUrl.announcementList +
        "/" +
        this.pageNumber +
        "/" +
        this.pageSize +
        "/" +
        this.channel;
      http.getInAppPath(url).then(response => {
        if (response.code == 0) {
          if (response.data && response.data.total != 0) {
            this.announceInfo = response.data.list;
            this.title = response.data.list[0].announcementName
              ? response.data.list[0].announcementName
              : "";
            this.isShow = true;
          } else {
            this.isShow = false;
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.announce-box {
  width: 100%;
  padding: 50px 350px 0 350px;
  box-sizing: border-box;
  .top-wrapper {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    line-height: 25px;
    color: #ccc;
    .head-box {
      display: inline-block;
    }
    .more {
      display: inline-block;
      color: #ccc;
    }
    .more:hover {
      color: #ccc;
      font-weight: 500;
      background: transparent;
    }

    span {
      img {
        vertical-align: text-top;
        width: 23px;
        height: 23px;
      }
    }
  }
  .announce-wrapper {
    width: 100%;
    margin-top: 22px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .announce-item:nth-child(3) {
    }
    .announce-item {
      display: inline-block;
      font-size: 16px;
      color: #333;
      line-height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: left;
      width: 48%;
      padding: 0;
      margin: 0;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .announce-item:nth-child(even) {
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/announceBox.vue